import { gql } from "@apollo/client"
import { EledoUser } from "./UserQueries"
import { EledoAccount } from "./EledoAccountQueries"

export type EledoAccountMember = {
  account: EledoAccount
  user: EledoUser
  roles: [string]
}

export type EledoAccountMembers = {
  total: number
  items: [EledoAccountMember]
}

export type EledoAccountMembersData = {
  accountMembers: EledoAccountMembers
}

export type EledoAccountMembersVars = {
  limit?: number
  page?: number
}

export type EledoUserMembershipsData = {
  userMemberships: EledoAccountMembers
}

export type EledoUserMembershipsVars = {
  limit?: number
  page?: number
}

export const GET_ACCOUNT_MEMBERS = gql`
  query getAccountMembers($limit: Int, $page: Int) {
    accountMembers(limit: $limit, page: $page) { items { id user { id email } roles } total }
  }
`;

export const GET_USER_MEMBERSHIPS = gql`
  query getUserMemberships($limit: Int, $page: Int) {
    userMemberships(limit: $limit, page: $page) { items { id account { id name } roles } total }
  }
`;

export type EledoRemoveAccountMemberVars = {
  userId: string
}

export type EledoRemoveAccountMemberData = {
  removeAccountMember: number
}

export const REMOVE_ACCOUNT_MEMBER = gql`
  mutation removeAccountMember($userId: ObjectId!) {
    removeAccountMember(userId: $userId)
  }
`;

export type EledoAccountMemberRoleVars = {
  userId: string
  role: string
}

export type EledoAccountMemberRoleData = {
  removeAccountMember: number
}

export const ADD_ACCOUNT_MEMBER_ROLE = gql`
  mutation addAccountMemberRole($userId: ObjectId!, $role: String) {
    addAccountMemberRole(userId: $userId, role: $role) { user { id email } roles }
  }
`;

export const REMOVE_ACCOUNT_MEMBER_ROLE = gql`
  mutation removeAccountMemberRole($userId: ObjectId!, $role: String) {
    removeAccountMemberRole(userId: $userId, role: $role) { user { id email } roles }
  }
`;